import axios from 'axios';

const apiUrl = `https://hirecrap-backend-gcg3e8cmcgfwe6ef.westus2-01.azurewebsites.net/api/hirecrap`;

// Reusable API fetch function with caching
const fetchFromAPI = async (url, params = {}) => {
    try {
        const response = await axios.get(url, { params, timeout: 15000 });
        return response.data;
    } catch (error) {
        console.error(`Error fetching data from ${url}:`, error.message);
        throw error;
    }
};

// Fetch job details by ID
export const getUsJobG8JobDetails = async (id) => {
    return fetchFromAPI(`${apiUrl}/jobG8us/jobById/${id}`);
};

export const getRandomUsJob = async () => {
    return fetchFromAPI(`https://hirecrap-backend-gcg3e8cmcgfwe6ef.westus2-01.azurewebsites.net/api/jobs/getRandomJob`);
};

export const getUsJobG8Jobs = async (page = 1, limit = 50) => {
    return fetchFromAPI(`${apiUrl}/jobG8us/alljobs`, { page, limit });
};

export const getUsJobG8JobsByTitle = async (title) => {
    return fetchFromAPI(`${apiUrl}/jobG8us/search`, { title});
};

// Germany JobG8 API functions

export const getDeJobG8JobDetails = async (id) => {
    return fetchFromAPI(`${apiUrl}/jobG8de/jobById/${id}`);
};

export const getDeJobG8Jobs = async (page = 1, limit = 50) => {
    return fetchFromAPI(`${apiUrl}/jobG8de/alljobs`, { page, limit });
};

export const getDeJobG8JobsByTitle = async (title) => {
    return fetchFromAPI(`${apiUrl}/jobG8de/search`, { title});
};

// Australia JobG8 API functions

export const getAuJobG8JobDetails = async (id) => {
    return fetchFromAPI(`${apiUrl}/jobG8au/jobById/${id}`);
};

export const getAuJobG8Jobs = async (page = 1, limit = 50) => {
    return fetchFromAPI(`${apiUrl}/jobG8au/alljobs`, { page, limit });
};

export const getAuJobG8JobsByTitle = async (title) => {
    return fetchFromAPI(`${apiUrl}/jobG8au/search`, { title});
};

// France JobG8 API functions

export const getFrJobG8JobDetails = async (id) => {
    return fetchFromAPI(`${apiUrl}/jobG8fr/jobById/${id}`);
};

export const getFrJobG8Jobs = async (page = 1, limit = 50) => {
    return fetchFromAPI(`${apiUrl}/jobG8fr/alljobs`, { page, limit });
};

export const getFrJobG8JobsByTitle = async (title) => {
    return fetchFromAPI(`${apiUrl}/jobG8fr/search`, { title});
};